"use strict";

var _immutable = require("immutable");

var _reselect = require("reselect");

var getSession = function getSession(state) {
  return (0, _immutable.fromJS)(state).getIn(['auth', 'session']);
};

var getResourceState = function getResourceState(state) {
  return state.core.resources.products;
};

var getCardNameData = function getCardNameData(state) {
  return (0, _immutable.fromJS)(state).getIn(['modules', 'axp-benefits-wrapper', 'card']);
};

var getFilename = function getFilename(state) {
  return (0, _immutable.fromJS)(state).getIn(['config', 'localeFilename']);
};

var getProductsData = function getProductsData(state) {
  return state.core.resources.products.toJS();
};

var getLocaleData = function getLocaleData(state) {
  return (0, _immutable.fromJS)(state).getIn(['intl', 'activeLocale']);
};

var genericData = function genericData(data) {
  if (!data) return {};
  return data.toJS();
};

var getProductsFn = function getProductsFn(productsState) {
  return productsState.get('productsList');
};

var getProducts = (0, _reselect.createSelector)([getResourceState], getProductsFn);

var productsStateFn = function productsStateFn(productsState) {
  return productsState.get('selectedProduct');
};

var getSelectedProduct = (0, _reselect.createSelector)([getResourceState], productsStateFn);
var getSelectedProductObject = (0, _reselect.createSelector)([getProductsData], function (products) {
  var selectedProduct = products.selectedProduct;

  if (selectedProduct) {
    return products.productsList[selectedProduct];
  }

  return null;
});
var getLogin = (0, _reselect.createSelector)([getSession], function (login) {
  if (!login) {
    return false;
  }

  return true;
});
var getCardNameFromState = (0, _reselect.createSelector)([getCardNameData], genericData);
var getEnv = (0, _reselect.createSelector)([getFilename], function (env) {
  return env;
});
var getLocale = (0, _reselect.createSelector)([getLocaleData], function (rawLocale) {
  return rawLocale.toLowerCase().replace('-', '_');
}); // only use getCardName on higher level components with access to params
// pass card name to children if needed

var getCardNameFromParams = function getCardNameFromParams(state) {
  var ownProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (ownProps.cardname) {
    return {
      data: {
        cardname: ownProps.cardname
      }
    };
  }

  return null;
};

var getMembership = (0, _reselect.createSelector)([getProductsData], function (products) {
  var selectedProduct = products.selectedProduct;

  if (selectedProduct) {
    return products.productsList[selectedProduct].account.relationship;
  }

  return null;
});
module.exports = {
  getResourceState: getResourceState,
  getCardNameData: getCardNameData,
  genericData: genericData,
  getProductsFn: getProductsFn,
  productsStateFn: productsStateFn,
  getProducts: getProducts,
  getSelectedProduct: getSelectedProduct,
  getSelectedProductObject: getSelectedProductObject,
  getLogin: getLogin,
  getCardNameFromState: getCardNameFromState,
  getCardNameFromParams: getCardNameFromParams,
  getEnv: getEnv,
  getLocale: getLocale,
  getMembership: getMembership
};